import uSwitch from './uSwitch';
export default uSwitch;



// WEBPACK FOOTER //
// ./src/components/uSwitch/index.js